import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-h4 text--primary" }
const _hoisted_2 = { class: "text-h4 text--primary" }
const _hoisted_3 = { class: "text-h4 text--primary" }
const _hoisted_4 = { class: "text-h4 text--primary" }
const _hoisted_5 = { class: "text-h4 text--primary" }
const _hoisted_6 = { class: "text-h4 text--primary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_icon = _resolveComponent("v-list-item-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!

  return (_openBlock(), _createBlock(_component_v_row, {
    class: "pa-4",
    "no-gutters": ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { cols: "8" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "6",
                class: "pa-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    class: "rounded-xl fill-height",
                    elevation: "0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, null, {
                        default: _withCtx(() => _cache[9] || (_cache[9] = [
                          _createTextVNode("États des tâches récurrentes")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_v_card_text, null, {
                        default: _withCtx(() => _cache[10] || (_cache[10] = [
                          _createElementVNode("p", { class: "text--primary" }, "Dossiers actifs", -1),
                          _createElementVNode("div", { class: "text-h4 text--primary" }, "3 780", -1)
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "6",
                class: "pa-2"
              }),
              _createVNode(_component_v_col, {
                cols: "6",
                class: "pa-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    class: "rounded-xl fill-height",
                    elevation: "0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, null, {
                        default: _withCtx(() => _cache[11] || (_cache[11] = [
                          _createTextVNode("Déclarations fiscales")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_v_card_text, { class: "d-flex flex-column justify-center align-center" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            size: "small",
                            dark: "",
                            rounded: "",
                            elevation: "0",
                            class: "mr-2 mt-1",
                            color: "primary",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.generateTaxForms2(2025)))
                          }, {
                            default: _withCtx(() => _cache[12] || (_cache[12] = [
                              _createTextVNode(" Déclarations 2025 - Générer les formulaires ")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_btn, {
                            size: "small",
                            dark: "",
                            rounded: "",
                            elevation: "0",
                            class: "mr-2 mt-1",
                            color: "primary",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.generateTaxForms2(2024)))
                          }, {
                            default: _withCtx(() => _cache[13] || (_cache[13] = [
                              _createTextVNode(" Déclarations 2024 - Générer les formulaires ")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "6",
                class: "pa-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    class: "rounded-xl fill-height",
                    elevation: "0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, null, {
                        default: _withCtx(() => _cache[14] || (_cache[14] = [
                          _createTextVNode("Liasses fiscales")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_v_card_text, { class: "d-flex flex-column justify-center align-center" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            size: "small",
                            dark: "",
                            rounded: "",
                            elevation: "0",
                            class: "mr-2 mt-1",
                            color: "primary",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.generateBundleTaxForms(2025)))
                          }, {
                            default: _withCtx(() => _cache[15] || (_cache[15] = [
                              _createTextVNode(" Liasses 2025 - Générer les formulaires ")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_btn, {
                            size: "small",
                            dark: "",
                            rounded: "",
                            elevation: "0",
                            class: "mr-2 mt-1",
                            color: "primary",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.generateBundleTaxForms(2024)))
                          }, {
                            default: _withCtx(() => _cache[16] || (_cache[16] = [
                              _createTextVNode(" Liasses 2024 - Générer les formulaires ")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "6",
                class: "pa-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    class: "rounded-xl fill-height",
                    elevation: "0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, null, {
                        default: _withCtx(() => _cache[17] || (_cache[17] = [
                          _createTextVNode("Révision")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_v_card_text, { class: "d-flex flex-column justify-center align-center" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            rounded: "",
                            elevation: "0",
                            class: "mr-2 mt-1",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.generateAuditChecks())),
                            size: "small"
                          }, {
                            default: _withCtx(() => _cache[18] || (_cache[18] = [
                              _createTextVNode(" Générer les contrôles ")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_btn, {
                            rounded: "",
                            elevation: "0",
                            class: "mr-2 mt-1",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.generateAccountingReviewLayouts())),
                            size: "small"
                          }, {
                            default: _withCtx(() => _cache[19] || (_cache[19] = [
                              _createTextVNode(" Générer les dossiers de révision ")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "6",
                class: "pa-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    class: "rounded-xl fill-height",
                    elevation: "0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, null, {
                        default: _withCtx(() => _cache[20] || (_cache[20] = [
                          _createTextVNode("Metrics/KPIs")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_v_card_text, { class: "d-flex flex-column justify-center align-center" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, { class: "d-flex justify-center align-center" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { cols: "4" }),
                              _createVNode(_component_v_col, { cols: "4" }, {
                                default: _withCtx(() => _cache[21] || (_cache[21] = [
                                  _createElementVNode("p", { class: "text--primary" }, "Clients", -1)
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_v_col, { cols: "4" }, {
                                default: _withCtx(() => _cache[22] || (_cache[22] = [
                                  _createElementVNode("p", { class: "text--primary" }, "Dossiers", -1)
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_v_col, { cols: "4" }, {
                                default: _withCtx(() => _cache[23] || (_cache[23] = [
                                  _createElementVNode("p", { class: "text--primary" }, "Expert", -1)
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_v_col, { cols: "4" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.kpis.expertClientsCount), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, { cols: "4" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.kpis.expertFilesCount), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, { cols: "4" }, {
                                default: _withCtx(() => _cache[24] || (_cache[24] = [
                                  _createElementVNode("p", { class: "text--primary" }, "Business", -1)
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_v_col, { cols: "4" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.kpis.businessClientsCount), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, { cols: "4" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.kpis.businessFilesCount), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, { cols: "4" }, {
                                default: _withCtx(() => _cache[25] || (_cache[25] = [
                                  _createElementVNode("p", { class: "text--primary" }, "Totaux", -1)
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_v_col, { cols: "4" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.kpis.allClientsCount), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, { cols: "4" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.kpis.allFilesCount), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_ctx.localEnv !== 'production')
                ? (_openBlock(), _createBlock(_component_v_col, {
                    key: 0,
                    cols: "6",
                    class: "pa-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        class: "rounded-xl fill-height",
                        elevation: "0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_title, null, {
                            default: _withCtx(() => _cache[26] || (_cache[26] = [
                              _createTextVNode("Suivi d'apprentissage")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_card_text, { class: "d-flex flex-column justify-center align-center" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                rounded: "",
                                elevation: "0",
                                class: "mr-2 mt-1",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.syncTutorials())),
                                size: "small"
                              }, {
                                default: _withCtx(() => _cache[27] || (_cache[27] = [
                                  _createTextVNode(" Synchroniser les tutoriels ")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_v_btn, {
                                rounded: "",
                                elevation: "0",
                                class: "mr-2 mt-1",
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.syncModules())),
                                size: "small"
                              }, {
                                default: _withCtx(() => _cache[28] || (_cache[28] = [
                                  _createTextVNode(" Synchroniser les modules ")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "4",
        class: "pa-2"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, {
            class: "rounded-xl fill-height",
            elevation: "0"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, null, {
                default: _withCtx(() => _cache[29] || (_cache[29] = [
                  _createTextVNode("Centre de contrôle")
                ])),
                _: 1
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list, {
                    nav: "",
                    dense: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item, {
                        class: "oss-list-item",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.maintenance())),
                        "model-value": 'maintenance'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, { color: "primary" }, {
                                default: _withCtx(() => _cache[30] || (_cache[30] = [
                                  _createTextVNode("$fa-wrench")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" " + _toDisplayString(_ctx.applicationSetting.maintenance
                                    ? "Arreter la maintenance"
                                    : "Mettre bobbee en maintenance"), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}